import { userAxios } from "../index";

/**
 * Obtiene los agentes disponibles para el admin-agent autenticado.
 */
export const listAgents = async () =>
  userAxios.get("/get-agent-by-admin").then((response) => response.data);

/**
 * Recupera la información del dashboard del admin-agent.
 */
export const getDashboardData = async (payload) =>
  userAxios
    .post("/admin-agent-user/get-data", payload)
    .then((response) => response.data);

export default {
  listAgents,
  getDashboardData,
};

